import { IDotMenu } from './dotMenu.model';
import { OrderType } from '.';
import { TranslationsTypes } from './translation.model';

export type ISortMenuViewTypes = 'list' | 'tail';

export interface ISortMenuOrderbyTypes {
    name: string;
    value: string;
}

export interface IListPageBar {
    showMenu: boolean;
    showOrganizationsSelect: boolean;
    showJitOrganizationsSelect: boolean;
    showBullPhishOrganizationsSelect: boolean;
    bullPhishSelectedOrganization: string;
    viewType: ISortMenuViewTypes;
    orderbyTypes: ISortMenuOrderbyTypes[];
    currentSort?: ISortMenuOrderbyTypes;
    sortingEnabledOptions: IListPageBarEnabled;
    activeFilters: IActiveFilter[];
    orderBy: {
        property: string;
        direction: OrderType;
    };
    actionMenuOptions: IDotMenu[];
}

export interface IListPageBarEnabled {
    organizationsEnabled?: boolean;
    changeViewEnabled?: boolean;
    filtersViewEnabled?: boolean;
    orderByEnabled?: boolean;
    actionMenuEnabled?: boolean;
    launchpadSortingEnabled?: boolean;
}

export interface ISortingProps {
    filtersEnabled: boolean;
    organizationFilter: string;
    sortingActions: {
        showSortingMenu: Function;
        resetSortingMenu: Function;
        sortingEnabledOptions: Function;
    };
}

export interface IActiveFilter {
    name: string;
    value: string;
    label: string;
    filterBy?: string;
    displayValueName?: string;
}

export interface ITagFilterItem {
    filterBy?: string;
    value: string;
    label: string;
    type: string;
}

export interface IValueSuggestionsForFilter {
    id?: number;
    label: TranslationsTypes;
    value: string;
}

export interface IActiveFilterNew {
    type: string;
    value: string;
    label: TranslationsTypes;
    filterBy?: string;
    suggestionsForFilter?: IValueSuggestionsForFilter[];
}

export interface IFilterSelect {
    id: number;
    label: TranslationsTypes;
    value: string;
}

export enum FilterEnum {
    contains = 'contains',
    dateRange = 'dateRange',
    method = 'method',
    state = 'state',
    provisioningState = 'provisioningState',
    groups = 'groups',
    severity = 'severity',
    signinMethod = 'signinMethod',
    categoryId = 'categoryId',
    equals = 'eq',
    cast = 'cast',
    vaultPasswords = 'vaultPasswords',
    passwordsList = 'passwordsList',
    manualUpdateOnly = 'manualUpdateOnly',
    expiredOnly = 'expiredOnly',
    revealedAt = 'revealedAt',
    trueOrFalse = 'trueOrFalse'
}

export enum FilterValuesEnum {
    displayName = 'DisplayName',
    principalName = 'PrincipalName',
    name = 'Name'
}

export interface IGroupsDTO {
    Id: string;
    Name: string;
    OrganizationId: string;
    TenantId: string;
}

export interface IJitOrgsProps {
    id: string;
    name: string;
}

export interface IJitOrgsData {
    OrganizationId: string;
    OrganizationName: string;
}